/**
 * <TicketFormAccordion
 *    ticket={}
 *	/>
 *
 * @parent /ModalContent
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import locale from './locale'
import moment from 'moment';
import ApplicationForm from './ApplicationForm';
import placeOrder from 'controllers/ticket/placeOrder';
import Transition from 'components/UI/Transition';
import { confirm } from 'util/confirm';
import { alert } from 'util/alert'

const AddApplicant = ({ currentNumber, onClick })=>{
  return (
    <div className='add-applicant-button' onClick={onClick}>
      <span>{currentNumber || 0}</span>
      <i className='fa icon-plus'/>
    </div>
  );
}

class TicketFormAccordion extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.addApplicant = this.addApplicant.bind(this);
    this.onChange = this.onChange.bind(this);

    this.state = {
      applications: props.attendee || [],
      applicationErrors: [],
    }
  }

  onChange(index) {
    return (formData)=> {
      const applications = this.state.applications;
      applications[index] = {
        ...applications[index],
        ...formData,
      };

      this.setState({
        applications,
      }, ()=>{
        this.props.onChange(applications);
      });
    }
  }

  onDelete(index) {
    const {
      applications,
      applicationErrors,
    } = this.state;
    confirm(__('Are you sure you want to remove the applicant?', locale))
      .then((res) => {
        this.setState({
          applications: [...applications.slice(0,index), ...applications.slice(index+1)],
          applicationErrors: [...applicationErrors.slice(0,index), ...applicationErrors.slice(index+1)],
        }, ()=>{
          this.props.onChange(this.state.applications);
        });
      })
      .catch(() => {})
  }

  addApplicant() {
    const {
      id,
      end_at,
      amount,
      auto_wait_list,
      max_per_order,
    } = this.props.ticket;

    const newApplicant = {
      ticket_id: id,
      custom_data: {},
    }

    if(end_at && moment(end_at).format('YYYY-MM-DD HH:mm') < moment().format('YYYY-MM-DD HH:mm')){
      return alert.fail(__('Registration is closed', locale))
    }

    let applicants = [...this.state.applications, {...newApplicant} ]

    if(auto_wait_list == 0 && max_per_order !== null && applicants.length > max_per_order){
      return alert.fail(__('No more space left.', locale))
    }

    this.setState({
      applications: applicants,
      applicationErrors: [...this.state.applicationErrors, {} ],
    }, ()=>{
      this.props.onChange(this.state.applications);
    });
  }

  render() {

    const {
      registerValidate,
    } = this.props;

    const {
      applications,
      applicationErrors,
    } = this.state;

    const {
      title,
      ticket_type,
      start_at,
      end_at,
      auto_wait_list,
    } = this.props.ticket

    return (
      <div className='ticket-form-accordion-wrapper'>
        <div className='ticket-form-accordion-content'>
          <div className='ticket-form-accordion-header'>
            <section className='upper'>
              <h2>{title || "N/A"}</h2>
              <AddApplicant onClick={this.addApplicant} currentNumber={applications.length}/>
            </section>
            <section className='bottom'>
              <div className='deadline-date'>
                { end_at &&
                  __('Deadline', locale) + ': ' + moment(end_at).locale('en').format('DD MMMM YYYY, ddd hh:mm A')
                }
                { !end_at &&
                  __('Deadline: N/A', locale)
                }
              </div>
            </section>
          </div>
          <div className='form-list-wrapper'>
            <div className='form-list'>
              <Transition type='expand'>
              {applications.map((formData, key)=>{
                const isLastForm = !(applications.length > 1 && key != applications.length - 1);
                return (
                <ApplicationForm
                  onChange={this.onChange(key)}
                  key={key}
                  isLastForm={isLastForm}
                  onDelete={(key)=>this.onDelete(key)}
                  formData={applications[key]}
                  formError={applicationErrors[key]}
                  index={key}
                  registerValidate={registerValidate}
                  />
                );
              })}
              </Transition>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TicketFormAccordion;



// WEBPACK FOOTER //
// ./src/shared/RegisterClassModal/TicketFormAccordion.js